export const SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE = 'spaceSettingsDetails';
export const NOT_APPLICABLE = 'N/A';
